export default __webpack_public_path__ + "static/media/achievementImg.afd2323f.jpg";